import { Node } from 'tiptap';

export default class Audio extends Node {
    get name() {
        return 'audio';
    }

    get schema() {
        return {
            attrs: {
                src: {
                    default: null,
                },
                type: {
                    default: 'audio/mpeg',
                },
            },
            group: 'block',
            selectable: false,
            parseDOM: [
                {
                    tag: 'source',
                    getAttrs: (dom) => ({
                        src: dom.getAttribute('src'),
                        type: dom.getAttribute('type'),
                    }),
                },
            ],
            toDOM: (node) => [
                'div',
                {},

                [
                    'audio',
                    {
                        controls: true,
                    },
                    [
                        'source',
                        {
                            src: node.attrs.src,
                            type: node.attrs.type,
                        },
                    ],
                ],
            ],
        };
    }

    get view() {
        return {
            props: ['node', 'updateAttrs', 'view'],
            computed: {
                src: {
                    get() {
                        return this.node.attrs.src;
                    },
                    set(src) {
                        src;
                        this.updateAttrs({
                            src,
                        });
                    },
                },
                type: {
                    get() {
                        return this.node.attrs.type;
                    },
                    set(type) {
                        type;
                        this.updateAttrs({
                            type,
                        });
                    },
                },
            },
            render: function(createElement) {
                if (this.view.editable) {
                    // console.log(this.view)
                    // console.log(this.node)
                    // console.log(`Computed src: ${this.src}`)
                    // put into html dom
                    return createElement('div', [
                        createElement(
                            'audio',
                            {
                                attrs: {
                                    controls: '',
                                    contenteditable: true,
                                },
                            },
                            [
                                createElement('source', {
                                    attrs: {
                                        ...this.node.attrs,
                                    },
                                }),
                            ]
                        ),
                    ]);
                } else {
                    // Wrap it all in a div
                    return createElement('div', [
                        // https://vuejs.org/v2/guide/render-function.html#Complete-Example
                        createElement('audio', {
                            attrs: {
                                ...this.node.attrs,
                            },
                        }),
                    ]);
                }
            },
            // change this into render function
            // template: `
            //   <div class="audio">
            //     <audio class="audio__embed" :src="src"></audio>
            //     <input class="audio__input" @paste.stop type="text" v-model="src" v-if="view.editable" />
            //   </div>
            // `,
        };
    }
    // type in the commands function is destructured from
    //
    commands({ type }) {
        return (attrs) => (state, dispatch) => {
            const { selection } = state;
            const position = selection.$cursor ? selection.$cursor.pos : selection.$to.pos;
            const node = type.create(attrs);
            const transaction = state.tr.insert(position, node);
            dispatch(transaction);
        };
    }
}
